import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { HeatTraceComponent } from './heat-trace.component';
import { TestDetailsComponent } from './test-details/test-details.component';

const routes: Routes = [
  {
    path: '',
    component: HeatTraceComponent,
    children: [],
  },
  {
    path: ':tagNumber/cable/:elementTagNumber',
    component: TestDetailsComponent,
    children: [],
  },
  {
    path: ':tagNumber/junction-box/:elementTagNumber',
    component: TestDetailsComponent,
    children: [],
  },
  {
    path: ':tagNumber/heat-trace/:elementTagNumber',
    component: TestDetailsComponent,
    children: [],
  },
  {
    path: ':tagNumber/distribution-board/:elementTagNumber',
    component: TestDetailsComponent,
    children: [],
  },
  {
    path: ':tagNumber/cubicle/:elementTagNumber',
    component: TestDetailsComponent,
    children: [],
  },
  {
    path: ':tagNumber',
    component: TestDetailsComponent,
    children: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HeatTraceRoutingModule {}
